// angular import
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// project import
import { NavBarComponent } from './toolbar.component';
import { NavLeftComponent } from './toolbar-left/toolbar-left.component';
import { NavRightComponent } from './toolbar-right/toolbar-right.component';
import { SharedModule } from 'src/app/shared/shared/shared.module';
import { ListItemComponent } from "../../../shared/components/dashboard-list/list-item/list-item.component";

@NgModule({
  declarations: [NavBarComponent, NavLeftComponent, NavRightComponent],
  imports: [CommonModule, SharedModule, ListItemComponent],
  exports: [NavBarComponent]
})
export class NavBarModule {}
